import { render, staticRenderFns } from "./winPage.vue?vue&type=template&id=45a4778c&scoped=true&"
import script from "./winPage.vue?vue&type=script&lang=js&"
export * from "./winPage.vue?vue&type=script&lang=js&"
import style0 from "./winPage.vue?vue&type=style&index=0&id=45a4778c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45a4778c",
  null
  
)

export default component.exports